/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.TrackChirpService
 */
import * as References from './TrackChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.TrackChirpService#getHydratedTrack
 */
export const GET_HYDRATED_TRACK_QUERY_FIELD_NAME = 'com_hubspot_academy_catalog_rpc_TrackChirpService_getHydratedTrack';
export const GET_HYDRATED_TRACK_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_HYDRATED_TRACK_QUERY_FIELD_NAME,
  args: ['trackId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getHydratedTrackRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});